import { Modal } from '@/components/Modal/Modal'
import { strings } from '@/strings'

interface DeletePostConfirmModalProps {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => void
}

export function DeletePostConfirmModal({
    isOpen,
    onClose,
    onConfirm,
}: DeletePostConfirmModalProps) {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={strings.posts.deleteTitle}
            confirmLabel={strings.posts.deleteConfirm}
            onConfirm={() => {
                onClose()
                onConfirm()
            }}
            isDestructive
        >
            <p>{strings.posts.deleteBody}</p>
        </Modal>
    )
}
